export default theme => ({
  root: {
    backgroundColor: theme.palette.grey.eccoGrey,
    width: "100%",
    color: theme.palette.common.white,
    left: 0,
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(["4", 8], ["5", 10])
    },
    [theme.breakpoints.down("md")]: {
      padding: "24px 0px 24px 14px"
    },
  /*   [theme.breakpoints.down("xs")]: {
      height: "auto"
    }, */
  },

  rootAsociate: {
    height: "160px",
    backgroundColor: theme.palette.grey.eccoGrey,
    width: "100%",
    color: theme.palette.common.white,
    left: 0,
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(["4", 8], ["5", 10])
    },
    [theme.breakpoints.down("md")]: {
      padding: "24px 0px 24px 14px"
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto"
    },
  },

  itemDense: {
    padding: 0
  },

  LinkDense: {
    padding: 4,
    [theme.breakpoints.up("xs")]: {
      textAlign: "center"
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "left"
    },
  },

  LinkDense2: {
    /* padding: 4, */
    /* [theme.breakpoints.up("xs")]: {
      textAlign: "center"
    }, */

    [theme.breakpoints.up("md")]: {
      "&.MuiListItemText-root": {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "40px"
      }
    },
    [theme.breakpoints.only("sm")]: {
      "&.MuiListItemText-root": {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "30px"
      }
    }
  },

  textDense: {
    margin: 0,
  },
  textDenseMobile: {
    margin: 0,
    marginLeft: 20,
  },

  text: {
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(10)
    },
    fontWeight: theme.typography.fontWeightLight
  },

  textM: {
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(10)
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: theme.typography.pxToRem(9)
    },

    fontWeight: theme.typography.fontWeightLight
  },

  textMobile: {
    fontSize: theme.typography.pxToRem(13)
  },

  textRedes: {
    marginTop: "-10px",
    marginBottom: "10px",
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(10)
    },
    fontWeight: theme.typography.fontWeightLight
  },

  crossIconRedes: {
    marginTop: "10px"
  },

  textLink: {
    [theme.breakpoints.up("md")]: {
      fontSize: theme.typography.pxToRem(16)
    },
    [theme.breakpoints.down("md")]: {
      fontSize: theme.typography.pxToRem(13)
    },

    fontWeight: theme.typography.fontWeightLight
  },

  borderRight: {
    [theme.breakpoints.up("xs")]: {
      borderRight: "1px solid"
    }
  },

  borderLeft: {
    height: "100%",
    marginTop: 15,
    [theme.breakpoints.up("xs")]: {
      borderLeft: "1px solid",
      borderRight: "1px solid"
    }
  },
  borderLeftRedes: {
    marginTop: "-50px",//"-10px",
    height: "60px !important",
    paddingLeft: "40px",
    [theme.breakpoints.up("xs")]: {
      borderLeft: "1px solid",
    },
    [theme.breakpoints.only("sm")]: {
      marginTop: "15px",
      height: "42px !important",
    },
  },

  wrappedlogoSmg: {
    [theme.breakpoints.up("sm")]: {
      textAlign: "center"
    },
    [theme.breakpoints.down("xs")]: {
      borderLeft: "1px solid",
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: "20px",
    }
  },

  line: {
    width: 60,
    margin: 0
  },

  wrappedLogoLegal: {
    padding: "2px 0",

    "& img": {
      width: 102,
      height: 50,

      "&:nth-child(1)": {
        paddingRight: theme.spacing(["5", 2])
      }
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -40,
    },
    [theme.breakpoints.down("xs")]: {
      "& img": {
        width: 80,
        height: 50,

        "&:nth-child(1)": {
          paddingRight: theme.spacing(["5", 2])
        }
      },
    }
  },

  wrapper: {
    [theme.breakpoints.up("md")]: {
      alignItems: "center"
    },
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }
  },

  smgImage: {
    [theme.breakpoints.down("xs")]: {
      height: 40,
      width: 120
    },
    // [theme.breakpoints.between("sm", "md")]: {
    //   height: 50,
    //   width: 135
    // },
    [theme.breakpoints.only("sm")]: {
      height: 40,
      width: 140
    },
    [theme.breakpoints.up("md")]: {
      height: 54,
      width: 172
    },

  },
  smgImageMobile: {
    height: 40,
    width: 140,
  },
  smgImageMobileLanding: {
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      // marginTop: "-125px",
      marginLeft: "5%",
      height: 40,
      width: 140
    },
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      // marginTop: "-125px",
      marginLeft: "5%",
      height: 40,
      width: 140
    },
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      marginTop: "-60px",
      marginLeft: "5%",
      height: 40,
      width: 140
    }
  },
  info: {
    [theme.breakpoints.only("sm")]: {
      marginTop: 10
    },
    [theme.breakpoints.up("md")]: {
      marginTop: -50
    },
  },
  socialIcons: {
    height: "30px",
    width: "30px",
    borderRadius: "5px",
    margin: "0 12px"
  },
  crossIcon: {
    [theme.breakpoints.up("md")]: {
      // marginTop: -20
    },
    padding: "2px 0",
    // marginLeft: "-90px",

    "& img": {
      width: 30,
      height: 20,

      "&:nth-child(1)": {
        paddingRight: theme.spacing(["5", 2])
      }
    },

    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
      "& img": {
        width: 20,
        height: 10,

        "&:nth-child(1)": {
          paddingRight: theme.spacing(["5", 2])
        }
      },
    }
  },
  redesMobile: {
    marginTop: "-10px",
    marginBottom: "10px",
  },
  img1: {
    marginLeft: 20
  },
  img2: {
    [theme.breakpoints.only("sm")]: {
      marginLeft: 20
    },
  }
});
